import { render, staticRenderFns } from "./Puestos.vue?vue&type=template&id=5fa4e666&scoped=true"
import script from "./Puestos.vue?vue&type=script&lang=js"
export * from "./Puestos.vue?vue&type=script&lang=js"
import style0 from "./Puestos.vue?vue&type=style&index=0&id=5fa4e666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa4e666",
  null
  
)

export default component.exports